import { IMenuActivity } from '../../../../Menu/Store/IMenuActivity'
import { IExtraActivity } from '../../../../ExtraActivity/Client/IExtraActivity'
import { IPreviousAppointmentActivity } from '../../../../PreviousAppointments/IPreviousAppointment'

export const isSelectAPerson = (
  activities: IMenuActivity[] | IExtraActivity[] | IPreviousAppointmentActivity[]
): boolean => activities.some(
  (activity: IMenuActivity | IExtraActivity | IPreviousAppointmentActivity) => activity.isPersonSelectable)
